import React, { useState } from 'react';
import IActivityProps from '../../../../dtos/IActivitiesProps';
import IStepProps from '../../../../dtos/IStepsProps';
import { Container, PlayerWrapper } from './styles';
import VideoPlayer from '../../../../components/VideoPlayer';

interface IComponentProps {
  currentActivity: IActivityProps;
  currentStep: IStepProps;
}

const VideoComponent: React.FC<IComponentProps> = ({ currentStep: step }) => {
  const [theater, setTheater] = useState(false);

  return (
    <Container $theater={theater}>
      <PlayerWrapper $theater={theater}>
        <VideoPlayer
          url={step.resource_url}
          theater={theater}
          onToggleTheater={() => setTheater(current => !current)}
        />
      </PlayerWrapper>
    </Container>
  );
};

export default VideoComponent;
